import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/alert/shared/alert.service';
import { AlertTypes } from '../../shared/alert/shared/alert-types';
import { UserDataService } from '../../user/shared/services/user-data.service';
import { UserService } from '../../user/shared/services/user.service';
import { LoginService } from '../../user/shared/services/login.service';

@Component({
  selector: 'avs-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent {
  public isLoading = false;
  private readonly redirectUrl: string;
  private readonly loggedIn: boolean;
  private accepted = false;

  constructor(
    private readonly userService: UserService,
    private readonly userDataService: UserDataService,
    private readonly alertService: AlertService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly loginService: LoginService
  ) {
    this.redirectUrl = this.route.snapshot.queryParamMap.get('redirect') || '/';
    this.loggedIn = this.loginService.isLogInValid();

    // Aktuellen Zustimmungsstatus laden (Seite ist auch per Footer erreichbar, ausserhalb des
    // Layout-Resolvers). Der Akzeptieren-Button erscheint nur, solange noch NICHT zugestimmt wurde.
    if (this.loggedIn) {
      this.loginService.getUserViaJwtToken().subscribe({
        next: (userData) => {
          this.accepted = userData.acceptTerms === true;
          this.userDataService.updateUserData(userData);
        },
        error: () => { /* Status unbekannt -> Akzeptieren bleibt sichtbar */ }
      });
    }
  }

  // Nur im erzwungenen Consent-Flow: eingeloggt UND noch nicht zugestimmt. Der Widerruf erfolgt
  // in den Benutzereinstellungen, nicht hier.
  public get showAcceptButton(): boolean {
    return this.loggedIn && !this.accepted;
  }

  public onAcceptClicked(): void {
    this.isLoading = true;

    this.userService.acceptTerms().subscribe({
      next: (userData) => {
        this.userDataService.updateUserData(userData);
        this.alertService.alert('Datenschutzbedingungen akzeptiert.', AlertTypes.success);
        this.router.navigateByUrl(this.redirectUrl);
        this.isLoading = false;
      },
      error: () => {
        this.alertService.alert('Die Zustimmung konnte nicht gespeichert werden.', AlertTypes.error);
        this.isLoading = false;
      }
    });
  }
}
